import { render, staticRenderFns } from "./GestionCursosCatequesis.vue?vue&type=template&id=5b9c691d&"
import script from "./GestionCursosCatequesis.vue?vue&type=script&lang=js&"
export * from "./GestionCursosCatequesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports